import { useMemo } from 'react';

import { SubHeadline, Text } from '~components/Typography';
import { useUserId } from '~hooks/useUserId';
import { subscriptionApi } from '~services/api/subscription';
import { Loader } from '~shared/ui/atoms';

import { PremiumContainer, PremiumList, PremiumListItem } from './styled';

type BenefitItem = {
	title: string;
	description?: string;
};

type Benefit = {
	callToActionText: string;
	title?: string;
	items: BenefitItem[];
};

type PremiumFeaturesPureProps = {
	title?: string;
	isLoading?: boolean;
	benefits: Benefit[];
};

export const PremiumFeaturesPure = ({
	title,
	isLoading = false,
	benefits = [],
}: PremiumFeaturesPureProps) => {
	const allFeatures = useMemo(
		() => benefits.flatMap((benefit) => benefit.items),
		[benefits]
	);

	return (
		<PremiumContainer>
			<SubHeadline size="M" align="left">
				{title}
			</SubHeadline>

			{isLoading ? (
				<Loader size={30} />
			) : (
				<PremiumList>
					{allFeatures.map((feature) => (
						<PremiumListItem key={feature.title}>
							<Text size="M" align="left">
								{feature.title}
							</Text>
						</PremiumListItem>
					))}
				</PremiumList>
			)}
		</PremiumContainer>
	);
};

export const PremiumFeatures = ({ title }: { title: string }) => {
	const userId = useUserId();

	const { data = { benefits: [] }, isLoading } =
		subscriptionApi.useGetSubscriptionBenefitsQuery({
			id: userId,
		});

	return (
		<PremiumFeaturesPure
			title={title}
			isLoading={isLoading}
			benefits={data.benefits}
		/>
	);
};
